import { atmBackConfiguration } from "@/setup/restAtmBackClient";
import { DocumentsApi } from "@socotec.io/atm-back-sdk";

const api = new DocumentsApi(atmBackConfiguration);

/**
 * Trigger an async DooApp report import for a case.
 * @param {string} caseUuid the ATM case uuid (the endpoint resolves the GED project server-side)
 * @returns {Promise<{status: string}>} 202 acknowledgement
 */
export const getDooAppReport = async (caseUuid) => {
  return await api.reportImports({ uuid: caseUuid });
};
